import { createEffect } from "effector";
import { restGetUniqueHandler } from "@utils/rest/RestClient";
import configuration from "@utils/Config";
import { AppInfosResponseDto } from "@state/app/response/app.infos.response.dto";

export const requestAppInfos = createEffect({
  handler: restGetUniqueHandler<AppInfosResponseDto>(
    configuration.backendBaseUrl + "/app/infos",
  ),
});
